import * as z from "zod/v4";

const PreviewPickLineSchema_ = z.object({
  productId: z.string(),
  productName: z.string().nullish(),
  productSku: z.string().nullish(),
  quantityRequired: z.number(),
  binName: z.string().nullish(),
  binAvailable: z.number().nullish(),
});
export const PreviewPickLineSchema: z.ZodType<PreviewPickLine> =
  PreviewPickLineSchema_;
export interface PreviewPickLine
  extends z.infer<typeof PreviewPickLineSchema_> {}

export const previewWorkOrder = {
  name: "previewWorkOrder" as const,
  input: z.object({ workOrderId: z.string() }),
  output: z.object({ pickLines: z.array(PreviewPickLineSchema) }),
};
